import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './en.js'
import ru from './ru.js'
import validationEn from './validation.en.js'
import validationRu from './validation.ru.js'
import {pluralizerRu} from 'js-core/helpers/localization'

Vue.use(VueI18n)

let browserLanguage = navigator.language

if (browserLanguage !== 'en' && navigator.language !== 'ru') {
    browserLanguage = 'en'
}

const enMessages = {...en, ...validationEn}
const ruMessages = {...ru, ...validationRu}

const i18n = new VueI18n({
    fallbackLocale: 'ru',
    locale: browserLanguage,
    messages: {
        ru: ruMessages,
        en: enMessages
    },
    pluralizationRules: {
        'ru': pluralizerRu
    }
})

export default i18n